import React, { useRef } from 'react'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import IdleTimer from 'react-idle-timer'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import PrivateRoute from './PrivateRoute'
import PrivacyNotice from '../PrivacyNotice/index'
import FinesQuestion from '../FinesQuestion/index'
import FinesYes from '../FinesYes/index'
import YourInformation from '../YourInformation/index'
import CannotProcessFee from '../CannotProcessFee/index'
import ReviewConfirmation from '../ReviewConfirmation/index'
import ReceiveConfirmation from '../ReceiveConfirmation/index'
import Confirmation from '../Confirmation/index'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'

const DefaultedFinesRoutes = ({ t, i18n }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES

  const idleEl = useRef(null)

  const onIdle = () => {
    // history.push(`${match.path}${t('routes.privacy_notice')}`)
    history.push(`${match.path}${t('routes.fines_question')}`)
  }

  return (
    <React.Fragment>
      <IdleTimer ref={idleEl} element={document} onIdle={onIdle} debounce={250} timeout={1000 * 60 * parseFloat(idleMinutes)} />
      <Layout />
      <Switch>
        <Route path={`${match.path}${t('routes.not_found')}`} component={PageNotFound} />
        <PrivateRoute path={`${match.path}${t('routes.receive_confirmation')}/:transId/:transOwner`} component={ReceiveConfirmation} />
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.review_confirmation')}`} component={ReviewConfirmation} />
        <PrivateRoute path={`${match.path}${t('routes.cannot_process_fee')}`} component={CannotProcessFee} />
        <PrivateRoute path={`${match.path}${t('routes.your_info')}`} component={YourInformation} />
        <PrivateRoute path={`${match.path}${t('routes.fines_yes')}`} component={FinesYes} />
        {/* <PrivateRoute path={`${match.path}${t('routes.fines_question')}`} component={FinesQuestion} /> */}
        <Route path={`${match.path}${t('routes.fines_question')}`} component={FinesQuestion} />
        {/* <Route path={`${match.path}${t('routes.privacy_notice')}`} component={PrivacyNotice} /> */}
        <Redirect from={`/${i18n.language}/*`} to={`${match.path}${t('routes.not_found')}`} />
        {/* <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.privacy_notice')}`} /> */}
        <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.fines_question')}`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default withTranslation('common')(DefaultedFinesRoutes)
